import { Component, Input } from '@angular/core';
import { Customer, CustomerAccount } from '@inyova/models';

@Component({
  selector: 'app-reporting-data-table',
  templateUrl: './reporting-data-table.component.html',
  styleUrls: ['./reporting-data-table.component.scss'],
  standalone: false
})
export class ReportingDataTableComponent {
  columns = [
    { key: 'date', label: 'performance.columns.date' },
    { key: 'transfer', label: 'performance.columns.transfer' },
    { key: 'amount', label: 'performance.columns.amount' }
  ];

  @Input() data: [];
  @Input() sliceItem: number;
  @Input() customer: Customer;
  @Input() currency: CustomerAccount['currency'];

  // for happpy Typescript/Eslint
  returnZero(): number {
    return 0;
  }
}
